(function () {
  if (window.__minimogSizeGuideInitialized) return;
  window.__minimogSizeGuideInitialized = true;

  function mountSizeChartButtons(root) {
    const scope = root || document;
    const blocks = scope.querySelectorAll("[data-size-chart-block]");

    blocks.forEach(function (block) {
      const sourceButton = block.querySelector(".foxkit-sizechart-button");
      if (!sourceButton) return;

      const productInfo = block.closest("product-info") || document;
      const anchor = productInfo.querySelector("[data-size-chart-anchor]");
      if (!anchor) return;

      const label = anchor.querySelector(".m-product-option--label-size");
      if (!label) return;
      // Keep the source in its block so variant HTML replacements can remount the button.
      const button = Array.from(anchor.querySelectorAll("[data-open-sizeguide]")).find(function (item) {
        return item.dataset.sizeGuideId === sourceButton.dataset.sizeGuideId;
      }) || sourceButton.cloneNode(true);

      anchor.classList.remove("has-size-chart");
      label.classList.add("has-size-chart");

      if (button.parentElement !== label) {
        label.appendChild(button);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      mountSizeChartButtons(document);
    });
  } else {
    mountSizeChartButtons(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    mountSizeChartButtons(event.target);
  });

  document.addEventListener("product:variant-picker:ready", function (event) {
    mountSizeChartButtons(event.target.closest("product-info") || document);
  });

  window.addEventListener("resize", function () {
    mountSizeChartButtons(document);
  });

  document.addEventListener("click", function (event) {
    const trigger = event.target.closest("[data-open-sizeguide]");
    if (!trigger) return;

    event.preventDefault();

    const guideId = trigger.dataset.sizeGuideId;
    if (!guideId) return;

    const content = document.querySelector(`[data-size-guide-content="${guideId}"]`);
    if (!content || !content.innerHTML.trim()) return;

    const modal = new MinimogTheme.Modal();
    const html = document.createElement("div");
    const desktopWidth = Number.parseInt(trigger.dataset.desktopModalWidth, 10) || 500;
    const modalWidth = window.matchMedia("(min-width: 768px)").matches
      ? `${Math.min(500, Math.max(320, desktopWidth))}px`
      : "900px";

    html.innerHTML = content.innerHTML;
    modal.appendChild(html);
    modal.setWidth(modalWidth);
    modal.setSizes("m-size-guide");
    modal.open();
  });
})();
